import { Endpoints } from "@brg/api";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { BookEvents } from "../helper/bookEvents";
import { StyledDropdownListItem } from "shared/components/tooltips/ProjectTooltip";
import { AppTester } from "supporting";

export interface BookTooltipProps {
  isViewable?: boolean;
  isPublishable?: boolean;
  isDeletable?: boolean;
  isEditable?: boolean;
  isCanBeDraft?: boolean;
  isModerately?: boolean;
  identifier?: string;
  isReportable?: boolean;
  isTagModerator?: boolean;
  isCanNotParticipate?: boolean;
  onNotParticipate?: (projectId: string) => void;
  children?: ReactNode;
  repostTools?: any;
}

/**
 * **BookTooltip** - контент всплывающего меню со всеми необходимыми параметрами и настройками для книги.
 *
 * @param props
 */
export const BookTooltip: FC<BookTooltipProps & BookEvents> = (props) => {
  const { t } = useTranslation();

  const {
    isViewable,
    isPublishable,
    isEditable,
    isReportable,
    isDeletable,
    isCanBeDraft,
    identifier,
    isModerately,
    isTagModerator,
    isCanNotParticipate,
    children,
    repostTools,
    onRemoveFromFeed,
    onBookPublish,
    onBookDelete,
    onBookEdit,
    onBookMoveDrafts,
    onBookMoveModerate,
    onBookReport,
    onBookView,
    onNotParticipate,
  } = props;

  const isContinuumSite = AppTester.isContinuumSite();

  const fireEvent = (handler?: (s: string) => void) => (ev: React.MouseEvent) => {
    ev.preventDefault();
    ev.stopPropagation();
    handler?.(identifier ?? '');
  };

  const fireOpen = (ev: React.MouseEvent) => {
    ev.preventDefault();
    ev.stopPropagation()
    window.open((Endpoints.geograffee + "/api/Project/GetStatisticForProjest?projectId=" + identifier), '_blank')?.focus();
  };
 
  return (
    <>
        {isViewable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookView)}>{t('view').toLowerCase()}</StyledDropdownListItem>
        )}
        {isEditable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookEdit)}>{t('edit').toLowerCase()}</StyledDropdownListItem>
        )}
        {isPublishable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookPublish)}>{t('publish').toLowerCase()}</StyledDropdownListItem>
        )}
        {isCanBeDraft && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookMoveDrafts)}>{t('move_drafts').toLowerCase()}</StyledDropdownListItem>
        )}
        {isModerately && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookMoveModerate)}>{t('moderate').toLowerCase()}</StyledDropdownListItem>
        )}
        {isDeletable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookDelete)}>{t('delete').toLowerCase()}</StyledDropdownListItem>
        )}
        {isReportable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookReport)}>{t('send_report').toLowerCase()}</StyledDropdownListItem>
        )}
        {isTagModerator && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireOpen}>{t('moder_log').toLowerCase()}</StyledDropdownListItem>
        )}
        {isCanNotParticipate && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onNotParticipate)}>{t('not_participate').toLowerCase()}</StyledDropdownListItem>
        )}
        {children}
    </>
  );
};
import { Endpoints } from "@brg/api";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { BookEvents } from "../helper/bookEvents";
import { StyledDropdownListItem } from "shared/components/tooltips/ProjectTooltip";
import { AppTester } from "supporting";

export interface BookTooltipProps {
  isViewable?: boolean;
  isPublishable?: boolean;
  isDeletable?: boolean;
  isEditable?: boolean;
  isCanBeDraft?: boolean;
  isModerately?: boolean;
  identifier?: string;
  isReportable?: boolean;
  isTagModerator?: boolean;
  isCanNotParticipate?: boolean;
  onNotParticipate?: (projectId: string) => void;
  children?: ReactNode;
  repostTools?: any;
}

/**
 * **BookTooltip** - контент всплывающего меню со всеми необходимыми параметрами и настройками для книги.
 *
 * @param props
 */
export const BookTooltip: FC<BookTooltipProps & BookEvents> = (props) => {
  const { t } = useTranslation();

  const {
    isViewable,
    isPublishable,
    isEditable,
    isReportable,
    isDeletable,
    isCanBeDraft,
    identifier,
    isModerately,
    isTagModerator,
    isCanNotParticipate,
    children,
    repostTools,
    onRemoveFromFeed,
    onBookPublish,
    onBookDelete,
    onBookEdit,
    onBookMoveDrafts,
    onBookMoveModerate,
    onBookReport,
    onBookView,
    onNotParticipate,
  } = props;

  const isContinuumSite = AppTester.isContinuumSite();

  const fireEvent = (handler?: (s: string) => void) => (ev: React.MouseEvent) => {
    ev.preventDefault();
    ev.stopPropagation();
    handler?.(identifier ?? '');
  };

  const fireOpen = (ev: React.MouseEvent) => {
    ev.preventDefault();
    ev.stopPropagation()
    window.open((Endpoints.geograffee + "/api/Project/GetStatisticForProjest?projectId=" + identifier), '_blank')?.focus();
  };
 
  return (
    <>
        {isViewable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookView)}>{t('view').toLowerCase()}</StyledDropdownListItem>
        )}
        {isEditable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookEdit)}>{t('edit').toLowerCase()}</StyledDropdownListItem>
        )}
        {isPublishable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookPublish)}>{t('publish').toLowerCase()}</StyledDropdownListItem>
        )}
        {isCanBeDraft && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookMoveDrafts)}>{t('move_drafts').toLowerCase()}</StyledDropdownListItem>
        )}
        {isModerately && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookMoveModerate)}>{t('moderate').toLowerCase()}</StyledDropdownListItem>
        )}
        {isDeletable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookDelete)}>{t('delete').toLowerCase()}</StyledDropdownListItem>
        )}
        {isReportable && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onBookReport)}>{t('send_report').toLowerCase()}</StyledDropdownListItem>
        )}
        {isTagModerator && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireOpen}>{t('moder_log').toLowerCase()}</StyledDropdownListItem>
        )}
        {isCanNotParticipate && (
          <StyledDropdownListItem isContinuumSite={isContinuumSite} onClick={fireEvent(onNotParticipate)}>{t('not_participate').toLowerCase()}</StyledDropdownListItem>
        )}
        {children}
    </>
  );
};
